<template>
    <section>
      <div class="main-product">
        <div class="product-card">
          <div class="left">
            <div class="product-data">
                <h2>One Dear Thing #1</h2>
                <h1>{{product.name}}</h1>
                <h6>Details</h6>
                <p>{{product.byLine}}</p>
                <div v-for="p in product.sizes" :key="p.id">
                    <p class="name">{{ p.name }} {{ p.value }}</p>
                </div>
                <div class="description">
                  <h6>Care</h6>
                  <p>Wash at 60° C</p>
                  <p>Iron or mangle</p>
                  <h6>Journey</h6>
                  <p v-html="product.description"></p>
                </div>
                
                <div class="price">
                  <p class="price-value">{{ price(product) }}</p>
                </div>
                <button class="button-dark" v-on:click="addToCart(product)">Add to Cart</button>
              </div>
          </div>
          <div class="right">
            <div class="product-image">
                <img :src="product.imageUrl" :alt="product.name">
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: "mainProduct",
  methods: {
  addToCart(product) {
      this.$store.dispatch('CART/ADD', product)
    },
    price (product) {
       return this.currencyFormatter(product).replace("kr", "SEK"); 
    },
    currencyFormatter(product) {
      //todo: get localization
      var localization = 'sv-SE';
      return new Intl.NumberFormat(localization, {
          style: 'currency',
          currency: !product.currency ? 'SEK' : product.currency,
          minimumFractionDigits: 0
      }).format(product.price);
    }
  },
  computed: {
    product() {
      return this.$store.getters['PRODUCTS/PRODUCT']
    }
  },
}
</script>

<style lang="postcss" scoped>

.main-product {width: 100%; margin: auto; padding: 10% 10% 10% 10%; }
.product-card {
  width: 100%;
  margin: auto;
  text-align: left;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex: 1;
}
.left { width: 40%; order: 0; }
.right { width: 50%; order: 1; }
.product-data { padding-left: 30%; }
.product-image { margin-top: 20%  }
.sizes { width: 50%;padding-bottom: 10%; float: left; }
.name { margin-bottom: 0; }
.value { margin: 0; }
.description {display: block; width: 100%;}
.product-information {margin-top: 10%; }
.product-information p { line-height: 0.7em; }

a { color: inherit;}

.product-data h1, h2 {
  width: 100%;
  margin: 0;
  padding: 0;
}
.product-data h1 {
  font-weight: 100;
  font-size: var(--font-size-xl);
  height: 60px;
  line-height: 2em;
  padding-bottom: 0.4em;
  text-align: center;
}
.product-data h2 {
  font-weight: 100;
  font-size: 1.1em;
  text-align: center;
  text-transform: uppercase;
  font-family: Didot;
}

.product-data h6 {
  text-transform: uppercase;
  padding: 0;
  margin: 0;
  margin-top: 1.5em;
  font-size: .8em;
}

.product-data p {
  padding: 0;
  margin: 0;
}

.price {
  margin-top: 1em;
  font-size: 1.3em;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}

 button {
   margin: 0 auto;
   margin-top: 10%;
   width: 256px;
}


@media screen and (max-width: 780px) {
  .product-data { padding-left:0%; padding: 5%;}
  .product-card h1 { font-size: 1.4em; padding-top: 10%;  padding-bottom: 0em;}
  .product-card h2 { font-size: 1.2em; }
  .left { width: 100%;max-width: 100%; }
  .right { display: none; }
  button {
    margin-left: auto; 
    margin-right:auto; 
    display: flex;
    justify-content: center;
  }
  .price {
    justify-content: flex-start;
    width: 100%;
  }

  .main-product {
    padding: 2%;
  }
}


</style>